import { breadcrumb } from './breadcrumb';
import { call } from './call';
import { trunk } from './trunk';
import { stats } from './stats';
import { iso } from './iso';

export const voice = {
  breadcrumb,
  call,
  trunk,
  stats,
  iso
};
